import { LocalizedForm } from "common/localization";

export default class RegisterForm extends LocalizedForm {
    constructor(hooks) {
        // Live-validate so the subscribe submit button can gate on form.isValid.
        // The base form only validates on submit (validateOnChange/Blur off by default),
        // which would keep isValid false while the user types and leave the button stuck
        // disabled. validateOnInit keeps isValid accurate for the pristine (empty) form so
        // the button starts disabled; showErrorsOnInit:false avoids showing red errors
        // before the user has interacted with a field.
        super(hooks, undefined, {
            validateOnInit: true,
            validateOnChange: true,
            validateOnBlur: true,
            showErrorsOnInit: false,
        });
    }

    setup() {
        return {
            fields: [
                {
                    name: "email",
                    label: "REGISTER.FIELDS.EMAIL_LABEL",
                    placeholder: "REGISTER.FIELDS.EMAIL_PLACEHOLDER",
                    rules: "required|email|string",
                },
                {
                    name: "confirmEmail",
                    label: "REGISTER.FIELDS.CONFIRM_EMAIL_LABEL",
                    placeholder: "REGISTER.FIELDS.CONFIRM_EMAIL_PLACEHOLDER",
                    rules: "required|email|string|same:email",
                },
                {
                    name: "firstName",
                    label: "REGISTER.FIELDS.FIRST_NAME_LABEL",
                    placeholder: "REGISTER.FIELDS.FIRST_NAME_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "lastName",
                    label: "REGISTER.FIELDS.LAST_NAME_LABEL",
                    placeholder: "REGISTER.FIELDS.LAST_NAME_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "password",
                    label: "REGISTER.FIELDS.PASSWORD_LABEL",
                    type: "password",
                    placeholder: "REGISTER.FIELDS.PASSWORD_PLACEHOLDER",
                    rules: [
                        "required",
                        "string",
                        "min:8",
                        "regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/",
                    ],
                },
                {
                    name: "confirmPassword",
                    label: "REGISTER.FIELDS.CONFIRM_PASSWORD_LABEL",
                    placeholder: "REGISTER.FIELDS.CONFIRM_PASSWORD_PLACEHOLDER",
                    rules: "required|string|same:password",
                    type: "password",
                },
                {
                    name: "privacyPolicy",
                    label: "REGISTER.FIELDS.PRIVACY_POLICY_LABEL",
                    rules: "accepted",
                    type: "checkbox",
                },
            ],
        };
    }
}
